<template>
  <Menu></Menu>
  <div id="box">
    <!-- =========================================================================================================== -->
    <div class="container mb-2 p-0">
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0 text-center">
          <h5 class="fw-bold d-inline-block bi-columns-gap">&nbsp; Manage Tires Specs</h5>
        </div>
        <div class="col-auto p-0 text-center">
          <button class="btn btn-dark w-100 bi-arrow-clockwise" @click="loadBrands(); loadSizes(); loadPatterns();" :disabled="isBusy || loading">&nbsp; Reload</button>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0">
          <hr>
        </div>
      </div>
      <!-- ----------------------------------------------- -->          
      <div class="row p-0">
        <!-- =========================================================================================================== -->
        <div class="col p-0">
          <div class="input-group w-100 mb-2">
            <span class="input-group-text bi-search"></span>
            <input class="form-control" type="text" placeholder="Search Brands" v-model.trim='brands_filter'>
          </div>
          <div class="input-group w-100 mb-2">
            <button v-if="$store.getters.access('brand_add')"  class="btn btn-success bi-plus-circle w-50" @click="showAddBrand()" :disabled="brands_isBusy || brands_loading">&nbsp; Add Brand</button>
            <button class="btn btn-dark bi-arrow-clockwise w-50" @click="loadBrands()" :disabled="brands_isBusy || brands_loading">&nbsp; Reload</button>
          </div>
          <table class="table table-sm table-bordered table-striped table-hover table-fixed">
            <!-- ----------------------------------------------- -->
            <thead>
              <tr class="table-dark">
                <th>Name</th>
                <th class="text-center w-100px"><span class="bi-gear"></span></th>
              </tr>
            </thead>
            <!-- ----------------------------------------------- -->
            <tbody style="height: calc(100vh - 230px)">
              <LoadingRow v-if="brands_isBusy"></LoadingRow>
              
              <tr v-for="brand in brands_filtered" :key="brand._id">
                <td>{{ brand.name }}</td>
                <td class="text-center w-100px">
                  <div class="input-group w-100">
                    <button v-if="$store.getters.access('brand_edit')" class="btn btn-sm btn-warning bi-pencil-fill w-50" @click="showEditBrand(brand)" :disabled="brands_loading"></button>
                    <button v-if="$store.getters.access('brand_del')" class="btn btn-sm btn-danger bi-trash w-50" @click="delBrand(brand)" :disabled="brands_loading"></button>
                  </div>
                </td>
              </tr>
            </tbody>
            <!-- ----------------------------------------------- -->
          </table>
        </div>
        <!-- =========================================================================================================== -->
        <div class="col">
          <div class="input-group w-100 mb-2">
            <span class="input-group-text bi-search"></span>
            <input class="form-control" type="text" placeholder="Search Sizes" v-model.trim='sizes_filter'>
          </div>
          <div class="input-group w-100 mb-2">
            <button v-if="$store.getters.access('size_add')" class="btn btn-success bi-plus-circle w-50" @click="showAddSize()" :disabled="sizes_isBusy || sizes_loading">&nbsp; Add Size</button>
            <button class="btn btn-dark bi-arrow-clockwise w-50" @click="loadSizes()" :disabled="sizes_isBusy || sizes_loading">&nbsp; Reload</button>
          </div>
          <table class="table table-sm table-bordered table-striped table-hover table-fixed">
            <!-- ----------------------------------------------- -->
            <thead>
              <tr class="table-dark">
                <th>Name</th>
                <th class="text-center w-100px"><span class="bi-gear"></span></th>
              </tr>
            </thead>
            <!-- ----------------------------------------------- -->
            <tbody style="height: calc(100vh - 230px)">
              <LoadingRow v-if="sizes_isBusy"></LoadingRow>
              
              <tr v-for="size in sizes_filtered" :key="size._id">
                <td>{{ size.name }}</td>
                <td class="text-center w-100px">
                  <div class="input-group w-100">
                    <button v-if="$store.getters.access('size_edit')" class="btn btn-sm btn-warning bi-pencil-fill w-50" @click="showEditSize(size)" :disabled="sizes_loading"></button>
                    <button v-if="$store.getters.access('size_del')" class="btn btn-sm btn-danger bi-trash w-50" @click="delSize(size)" :disabled="sizes_loading"></button>
                  </div>
                </td>
              </tr>
            </tbody>
            <!-- ----------------------------------------------- -->
          </table>
        </div>
        <!-- =========================================================================================================== -->
        <div class="col p-0">
          <div class="input-group w-100 mb-2">
            <span class="input-group-text bi-search"></span>
            <input class="form-control" type="text" placeholder="Search Patterns" v-model.trim='patterns_filter'>
          </div>
          <div class="input-group w-100 mb-2">
            <button v-if="$store.getters.access('pattern_add')" class="btn btn-success bi-plus-circle w-50" @click="showAddPattern()" :disabled="patterns_isBusy || patterns_loading">&nbsp; Add Pattern</button>
            <button class="btn btn-dark bi-arrow-clockwise w-50" @click="loadPatterns()" :disabled="patterns_isBusy || patterns_loading">&nbsp; Reload</button>
          </div>
          <table class="table table-sm table-bordered table-striped table-hover table-fixed">
            <!-- ----------------------------------------------- -->
            <thead>
              <tr class="table-dark">
                <th>Name</th>
                <th class="text-center w-100px"><span class="bi-gear"></span></th>
              </tr>
            </thead>
            <!-- ----------------------------------------------- -->
            <tbody style="height: calc(100vh - 230px)">
              <LoadingRow v-if="patterns_isBusy"></LoadingRow>
              
              <tr v-for="pattern in patterns_filtered" :key="pattern._id">
                <td>{{ pattern.name }}</td>
                <td class="text-center w-100px">
                  <div class="input-group w-100">
                    <button v-if="$store.getters.access('pattern_edit')" class="btn btn-sm btn-warning bi-pencil-fill w-50" @click="showEditPattern(pattern)" :disabled="patterns_loading"></button>
                    <button v-if="$store.getters.access('pattern_del')" class="btn btn-sm btn-danger bi-trash w-50" @click="delPattern(pattern)" :disabled="patterns_loading"></button>
                  </div>
                </td>
              </tr>
            </tbody>
            <!-- ----------------------------------------------- -->
          </table>
        </div>
        <!-- =========================================================================================================== -->
      </div>
    </div>
    <!-- =========================================================================================================== -->
  </div>
  <!-- =========================================================================================================== -->
  <!-- =========================================================================================================== -->
  <div id="addBrandModal" ref="addBrandModal" class="modal fade">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- ----------------------------------------------- -->
        <div class="modal-header">
          <h5 class="modal-title">Add New Brand</h5>
          <a class="btn-close" data-bs-dismiss='modal'></a>
        </div>
        <!-- ----------------------------------------------- -->
        <div class="modal-body">
          <div class="input-group w-100 mb-2">
            <span class="input-group-text w-25">Name</span>
            <input class="form-control" type="text" v-model.trim="newBrand">
          </div>
        </div>
        <!-- ----------------------------------------------- -->
        <div class="modal-footer">
          <div class="container">
            <div class="row">
              <div class="col">
                <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
              </div>
              <div class="col">
                <a class="btn btn-success w-100" @click="addBrand()">
                  <span v-if="brands_loading" class="spinner-border"></span>
                  <span>Add</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- ----------------------------------------------- -->
      </div>
    </div>
  </div>
  <!-- =========================================================================================================== -->
  <div id="editBrandModal" ref="editBrandModal" class="modal fade">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- ----------------------------------------------- -->
        <div class="modal-header">
          <h5 class="modal-title">Edit Brand: {{ editBrand.nameOriginal }}</h5>
          <a class="btn-close" data-bs-dismiss='modal'></a>
        </div>
        <!-- ----------------------------------------------- -->
        <div class="modal-body">
          <div class="input-group w-100 mb-2">
            <span class="input-group-text w-25">Name</span>
            <input class="form-control" type="text" v-model.trim="editBrand.name">
          </div>
        </div>
        <!-- ----------------------------------------------- -->
        <div class="modal-footer">
          <div class="container">
            <div class="row">
              <div class="col">
                <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
              </div>
              <div class="col">
                <a class="btn btn-success w-100" @click="saveBrand()">
                  <span v-if="brands_loading" class="spinner-border"></span>
                  <span>Save</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- ----------------------------------------------- -->
      </div>
    </div>
  </div>
  <!-- =========================================================================================================== -->
  <!-- =========================================================================================================== -->
  <div id="addSizeModal" ref="addSizeModal" class="modal fade">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- ----------------------------------------------- -->
        <div class="modal-header">
          <h5 class="modal-title">Add New Size</h5>
          <a class="btn-close" data-bs-dismiss='modal'></a>
        </div>
        <!-- ----------------------------------------------- -->
        <div class="modal-body">
          <div class="input-group w-100 mb-2">
            <span class="input-group-text w-25">Name</span>
            <input class="form-control" type="text" v-model.trim="newSize">
          </div>
        </div>
        <!-- ----------------------------------------------- -->
        <div class="modal-footer">
          <div class="container">
            <div class="row">
              <div class="col">
                <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
              </div>
              <div class="col">
                <a class="btn btn-success w-100" @click="addSize()">
                  <span v-if="sizes_loading" class="spinner-border"></span>
                  <span>Add</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- ----------------------------------------------- -->
      </div>
    </div>
  </div>
  <!-- =========================================================================================================== -->
  <div id="editSizeModal" ref="editSizeModal" class="modal fade">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- ----------------------------------------------- -->
        <div class="modal-header">
          <h5 class="modal-title">Edit Brand: {{ editSize.nameOriginal }}</h5>
          <a class="btn-close" data-bs-dismiss='modal'></a>
        </div>
        <!-- ----------------------------------------------- -->
        <div class="modal-body">
          <div class="input-group w-100 mb-2">
            <span class="input-group-text w-25">Name</span>
            <input class="form-control" type="text" v-model.trim="editSize.name">
          </div>
        </div>
        <!-- ----------------------------------------------- -->
        <div class="modal-footer">
          <div class="container">
            <div class="row">
              <div class="col">
                <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
              </div>
              <div class="col">
                <a class="btn btn-success w-100" @click="saveSize()">
                  <span v-if="sizes_loading" class="spinner-border"></span>
                  <span>Save</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- ----------------------------------------------- -->
      </div>
    </div>
  </div>
  <!-- =========================================================================================================== -->
  <!-- =========================================================================================================== -->
  <div id="addPatternModal" ref="addPatternModal" class="modal fade">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- ----------------------------------------------- -->
        <div class="modal-header">
          <h5 class="modal-title">Add New Pattern</h5>
          <a class="btn-close" data-bs-dismiss='modal'></a>
        </div>
        <!-- ----------------------------------------------- -->
        <div class="modal-body">
          <div class="input-group w-100 mb-2">
            <span class="input-group-text w-25">Name</span>
            <input class="form-control" type="text" v-model.trim="newPattern">
          </div>
        </div>
        <!-- ----------------------------------------------- -->
        <div class="modal-footer">
          <div class="container">
            <div class="row">
              <div class="col">
                <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
              </div>
              <div class="col">
                <a class="btn btn-success w-100" @click="addPattern()">
                  <span v-if="patterns_loading" class="spinner-border"></span>
                  <span>Add</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- ----------------------------------------------- -->
      </div>
    </div>
  </div>
  <!-- =========================================================================================================== -->
  <div id="editPatternModal" ref="editPatternModal" class="modal fade">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- ----------------------------------------------- -->
        <div class="modal-header">
          <h5 class="modal-title">Edit Pattern: {{ editPattern.nameOriginal }}</h5>
          <a class="btn-close" data-bs-dismiss='modal'></a>
        </div>
        <!-- ----------------------------------------------- -->
        <div class="modal-body">
          <div class="input-group w-100 mb-2">
            <span class="input-group-text w-25">Name</span>
            <input class="form-control" type="text" v-model.trim="editPattern.name">
          </div>
        </div>
        <!-- ----------------------------------------------- -->
        <div class="modal-footer">
          <div class="container">
            <div class="row">
              <div class="col">
                <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
              </div>
              <div class="col">
                <a class="btn btn-success w-100" @click="savePattern()">
                  <span v-if="patterns_loading" class="spinner-border"></span>
                  <span>Save</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- ----------------------------------------------- -->
      </div>
    </div>
  </div>
  <!-- =========================================================================================================== -->
</template>
<!-- ******************************************************** -->
<script>
  const $ = require('jquery');
  export default {
    name: 'SpecsPage',
    data(){
      return {
        brands_loading: false,
        sizes_loading: false,
        patterns_loading: false,
        
        brands: [],
        sizes: [],
        patterns: [],
        
        brands_isBusy: false,
        sizes_isBusy: false,
        patterns_isBusy: false,

        brands_filter: '',
        sizes_filter: '',
        patterns_filter: '',


        newBrand: '',
        editBrand: {
          id: '',
          name: '',
        },

        newSize: '',
        editSize: {
          id: '',
          name: '',
        },

        newPattern: '',
        editPattern: {
          id: '',
          name: '',
        },
      }
    },
    created() {
      this.loadBrands();
      this.loadSizes();
      this.loadPatterns();
    },
    mounted(){
    },
    //**********************************************************
    computed:{
      brands_filtered(){
        let filter = this.brands_filter.toLowerCase();
        return this.brands.filter((x)=>x.name.toLowerCase().includes(filter));
      },
      sizes_filtered(){
        let filter = this.sizes_filter.toLowerCase();
        return this.sizes.filter((x)=>x.name.toLowerCase().includes(filter));
      },
      patterns_filtered(){
        let filter = this.patterns_filter.toLowerCase();
        return this.patterns.filter((x)=>x.name.toLowerCase().includes(filter));
      },
    },
    //**********************************************************
    methods:{
      //**********************************************************
      async loadBrands(){
        this.brands_isBusy = true;
        this.brands = [];
        var ack = await this.$service.getBrands();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.brands = ack.data;
        }
        this.brands_isBusy = false;
      },
      //**********************************************************
      async loadSizes(){
        this.sizes_isBusy = true;
        this.sizes = [];
        var ack = await this.$service.getSizes();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.sizes = ack.data;
        }
        this.sizes_isBusy = false;
      },
      //**********************************************************
      async loadPatterns(){
        this.patterns_isBusy = true;
        this.patterns = [];
        var ack = await this.$service.getPatterns();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.patterns = ack.data;
        }
        this.patterns_isBusy = false;
      },
      //**********************************************************
      //**********************************************************
      //**********************************************************
      //**********************************************************
      async showAddBrand(){
        $('#addBrandModal').modal('show');
      },
      //**********************************************************
      async addBrand(){
        this.brands_loading = true;
        await this._addBrand();
        this.brands_loading = false;
      },
      //**********************************************************
      async _addBrand(){
        if(!this.newBrand){
          return this.$toast('Some Fields are empty', 'warning');
        }
        var ack = await this.$service.addBrand({
          name: this.newBrand
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#addBrandModal').modal('hide');
        this.$toast('Brand Added Successfuly', 'success');
        this.loadBrands();
      },
      //**********************************************************
      async showEditBrand(brand){
        this.editBrand.id = brand._id;
        this.editBrand.nameOriginal = brand.name;
        this.editBrand.name = brand.name;
        $('#editBrandModal').modal('show');
      },
      //**********************************************************
      async saveBrand(){
        this.loading = true;
        await this._saveBrand();
        this.loading = false;
      },
      //**********************************************************
      async _saveBrand(){
        if(!this.editBrand.name){
          return this.$toast('Some Fields are empty', 'warning');
        }
        var ack = await this.$service.editBrand({
          id: this.editBrand.id,
          name: this.editBrand.name,
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#editBrandModal').modal('hide');
        this.$toast('Brand Saved Successfuly', 'success');
        this.loadBrands();
      },
      //**********************************************************
      async delBrand(brand){
        var reply = await this.$swal.fire({
          title: "Confirm Delete",
          html: `Are you sure you want to delete the brand <b>${brand.name}</b>`,
          icon: "error", showCancelButton: true, focusCancel: true,
          confirmButtonText: "Confirm Delete", confirmButtonColor: "#d33", 
        });
        if(!reply.isConfirmed) return;
        this.loading = true;
        var ack = await this.$service.delBrand({ id: brand._id });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.$toast('Brand Deleted Successfuly', 'success');
          this.loadBrands();
        }
        this.loading = false;
      },
      //**********************************************************
      //**********************************************************
      //**********************************************************
      //**********************************************************
      async showAddSize(){
        $('#addSizeModal').modal('show');
      },
      //**********************************************************
      async addSize(){
        this.sizes_loading = true;
        await this._addSize();
        this.sizes_loading = false;
      },
      //**********************************************************
      async _addSize(){
        if(!this.newSize){
          return this.$toast('Some Fields are empty', 'warning');
        }
        var ack = await this.$service.addSize({
          name: this.newSize
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#addSizeModal').modal('hide');
        this.$toast('Size Added Successfuly', 'success');
        this.loadSizes();
      },
      //**********************************************************
      async showEditSize(size){
        this.editSize.id = size._id;
        this.editSize.nameOriginal = size.name;
        this.editSize.name = size.name;
        $('#editSizeModal').modal('show');
      },
      //**********************************************************
      async saveSize(){
        this.loading = true;
        await this._saveSize();
        this.loading = false;
      },
      //**********************************************************
      async _saveSize(){
        if(!this.editSize.name){
          return this.$toast('Some Fields are empty', 'warning');
        }
        var ack = await this.$service.editSize({
          id: this.editSize.id,
          name: this.editSize.name,
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#editSizeModal').modal('hide');
        this.$toast('Size Saved Successfuly', 'success');
        this.loadSizes();
      },
      //**********************************************************
      async delSize(size){
        var reply = await this.$swal.fire({
          title: "Confirm Delete",
          html: `Are you sure you want to delete the size <b>${size.name}</b>`,
          icon: "error", showCancelButton: true, focusCancel: true,
          confirmButtonText: "Confirm Delete", confirmButtonColor: "#d33", 
        });
        if(!reply.isConfirmed) return;
        this.loading = true;
        var ack = await this.$service.delSize({ id: size._id });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.$toast('Size Deleted Successfuly', 'success');
          this.loadSizes();
        }
        this.loading = false;
      },
      //**********************************************************
      //**********************************************************
      //**********************************************************
      //**********************************************************
      async showAddPattern(){
        $('#addPatternModal').modal('show');
      },
      //**********************************************************
      async addPattern(){
        this.patterns_loading = true;
        await this._addPattern();
        this.patterns_loading = false;
      },
      //**********************************************************
      async _addPattern(){
        if(!this.newPattern){
          return this.$toast('Some Fields are empty', 'warning');
        }
        var ack = await this.$service.addPattern({
          name: this.newPattern
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#addPatternModal').modal('hide');
        this.$toast('Pattern Added Successfuly', 'success');
        this.loadPatterns();
      },
      //**********************************************************
      async showEditPattern(pattern){
        this.editPattern.id = pattern._id;
        this.editPattern.nameOriginal = pattern.name;
        this.editPattern.name = pattern.name;
        $('#editPatternModal').modal('show');
      },
      //**********************************************************
      async savePattern(){
        this.loading = true;
        await this._savePattern();
        this.loading = false;
      },
      //**********************************************************
      async _savePattern(){
        if(!this.editPattern.name){
          return this.$toast('Some Fields are empty', 'warning');
        }
        var ack = await this.$service.editPattern({
          id: this.editPattern.id,
          name: this.editPattern.name,
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#editPatternModal').modal('hide');
        this.$toast('Pattern Saved Successfuly', 'success');
        this.loadPatterns();
      },
      //**********************************************************
      async delPattern(pattern){
        var reply = await this.$swal.fire({
          title: "Confirm Delete",
          html: `Are you sure you want to delete the pattern <b>${pattern.name}</b>`,
          icon: "error", showCancelButton: true, focusCancel: true,
          confirmButtonText: "Confirm Delete", confirmButtonColor: "#d33", 
        });
        if(!reply.isConfirmed) return;
        this.loading = true;
        var ack = await this.$service.delPattern({ id: pattern._id });
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.$toast('Pattern Deleted Successfuly', 'success');
          this.loadPatterns();
        }
        this.loading = false;
      },
      //**********************************************************
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
</style>
  